// extracted by mini-css-extract-plugin
module.exports = {"step":"GroupRegister_style_step__m_lgw"};